import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-sip-works-v2',
  templateUrl: './how-sip-works-v2.component.html',
  styleUrls: ['./how-sip-works-v2.component.scss']
})
export class HowSipWorksV2Component implements OnInit {

  @Input() config;

  DEFAULT_CONFIG = {
    theme: ''
  };

  card_points = [
    { image: '/assets/images/how-it-works/image-1.png', title: 'Automatic Monthly Contributions', text: 'Your contribution will be matched to a patient in urgent need of a life-saving treatment.' },
    { image: '/assets/images/how-it-works/image-2.png', title: 'Transparency on Contributions', text: 'We will ensure that every contribution reaches the patient each month.' },
    { image: '/assets/images/how-it-works/image-3.png', title: 'Receive Monthly Updates', text: 'You will come to know about the impact of your donation & the life you saved.' }
  ];

  infoText = [
    { title: 'Select causes to support', text: 'Give on your terms, to causes you care about.', img: '/assets/images/contact-finger.png' },
    { title: 'Track your impact', text: `Get regular updates on the lives you've supported.`, img: '/assets/images/message-bell.png' },
    { title: 'Unlock Special Rewards', text: 'Treat yourself to rewards that are exciting and healthy.', img: '/assets/images/gift.png' },
    { title: '100% Refund on Cancellation', text: 'Cancel or pause anytime - no questions asked!', img: '/assets/images/hand-rupee.png' },
  ];

  constructor() { }

  ngOnInit(): void {
    this.config = { ...this.DEFAULT_CONFIG, ...this.config };
  }

}
